module.exports = __webpack_public_path__ + "img/zip.1ead5aed.svg";